import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import ChargeTemplateFactory from "../../Entity/Factories/ChargeTemplateFactory";
import { ChargeTemplateInterface } from "../../Entity/Entities/Charge/ChargeTemplateInterface";

class ChargeTemplateDelete extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const chargeTemplate: ChargeTemplateInterface = ChargeTemplateFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_SUCCESS,
      payload: {
        chargeTemplate: chargeTemplate
      }
    });
  }

}

export { ChargeTemplateDelete };
